export default __webpack_public_path__ + "static/media/sustain.0e3ececc.webp";